import Http from './http'

export default {
  create(image_to_check){
    return Http.post(`/ai_flowise/validate_image`,{
      ...image_to_check
    });
  },
}